export default [
    { label: "Username", prop: "username", type: "text", group: "main", inputClass: "diagonal-wrap" },
    { label: "Password", prop: "password", type: "password", group: "main", inputClass: "diagonal-wrap", placeholder: "Enter a new password" },
    { label: "Role", prop: "role_id", type: "select", group: "main", metaGroup: "roles", labelKey: "name" },
    { label: "Locale", prop: "locale_id", type: "select", group: "main", metaGroup: "locales", labelKey: "description", empty: true },
    { label: "Plan", prop: "plan_id", type: "select", group: "main", metaGroup: "plans", labelKey: "name", empty: true },
]
